import { AbsoluteFill } from 'remotion';
import {
  useFullState,
  useDimensions,
  useSelectedItems,
} from '../utils/use-context';
import { VideoMaskHandles } from './video-mask-handles';

export const VideoMaskOverlay = () => {
  const { undoableState } = useFullState();
  const { compositionWidth, compositionHeight } = useDimensions();
  const { selectedItems } = useSelectedItems();
  const mask = undoableState.mask;

  // 비디오 타입 아이템이 선택되어 있을 때만 마스크 표시
  const isVideoItemSelected = selectedItems.some((itemId) => {
    const item = undoableState.items[itemId];
    return item?.type === 'video';
  });

  if (!mask || !mask.enabled || !isVideoItemSelected) {
    return null;
  }

  // 픽셀 단위로 변환
  const maskX = mask.x;
  const maskY = mask.y;
  const maskWidth = mask.width;
  const maskHeight = mask.height;

  // clip-path를 사용하여 마스크 영역 밖을 어둡게
  const clipPath = `polygon(
    0% 0%,
    0% 100%,
    ${(maskX / compositionWidth) * 100}% 100%,
    ${(maskX / compositionWidth) * 100}% ${(maskY / compositionHeight) * 100}%,
    ${((maskX + maskWidth) / compositionWidth) * 100}% ${(maskY / compositionHeight) * 100}%,
    ${((maskX + maskWidth) / compositionWidth) * 100}% ${((maskY + maskHeight) / compositionHeight) * 100}%,
    ${(maskX / compositionWidth) * 100}% ${((maskY + maskHeight) / compositionHeight) * 100}%,
    ${(maskX / compositionWidth) * 100}% 100%,
    100% 100%,
    100% 0%
  )`;

  return (
    <AbsoluteFill style={{ pointerEvents: 'none' }}>
      {/* 어두운 배경 (마스크 영역 밖) */}
      <AbsoluteFill
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          clipPath,
          pointerEvents: 'none',
        }}
      />
      {/* 파란색 테두리 (선택 불가, 드래그 불가) */}
      <AbsoluteFill
        style={{
          border: '1px solid var(--color-editor-starter-accent, #3b82f6)',
          left: maskX,
          top: maskY,
          width: maskWidth,
          height: maskHeight,
          pointerEvents: 'none',
        }}
      />
      {/* 핸들 (테두리만 드래그 가능) */}
      <VideoMaskHandles />
    </AbsoluteFill>
  );
};
